import React from 'react';

import classnames from 'clsx';
import PropTypes from 'prop-types';

import { ChildrenPropType } from '../../prop-types/children';
import style from './style.module.less';

export const InputLabel = ({ children, className = null, labelFor = null, hasError = false, required = false, disabled = false }) => (
  <label
    className={classnames(style['input-label'], { [style.error]: hasError }, { [style.disabled]: disabled }, className)}
    htmlFor={labelFor}
  >
    {children}
    {required && <span className={style['required-label']}> &lowast;</span>}
  </label>
);

InputLabel.propTypes = {
  children: ChildrenPropType.isRequired,
  className: PropTypes.string,
  labelFor: PropTypes.string,
  hasError: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};
